export const addPhoneMask = (number) => {
  if (!number) {
    return "";
  }

  // Remove non-digit characters and leading "+1"
  let cleaned = number && number.replace(/[^\d]/g, "").replace(/^1/, "");

  // Add phone mask
  let masked = cleaned.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");

  return masked;
};

export const removePhoneMask = (number) =>
  number && number.replace(/[^\d]/g, "");
